import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';

import {
    deleteMenu
} from '../../../../../../../../crud/menu_api/menus';
import { toast } from 'react-toastify';
import { HiOutlineXMark } from 'react-icons/hi2';
import MiniLoadingSpinner from '../../../../../../../../components/Spinners/MiniLoadingSpinner';

const DeleteMenuModal: React.FC<any> = ({
    show,
    handleClose,
    menu,
    menus,
    setMenus,
    setSelectedMenu
}) => {
    const [loading, setLoading] = useState(false);
    const [confirmText, setConfirmText] = useState('');

    const handleDeleteMenu = async () => {
        if (confirmText.toLowerCase() !== 'eliminar') {
            toast.error('Debes escribir "eliminar" para confirmar');
            return;
        }
        setLoading(true);
        deleteMenu(Number(menu?.menu_id))
            .then(() => {
                toast.success('Menú eliminado exitosamente');
                const updatedMenus = menus?.filter((m: any) => m.menu_id !== menu?.menu_id);
                setMenus(updatedMenus);
                setSelectedMenu(null);
                handleClose();
            })
            .catch((error) => {
                console.error('Error deleting menu:', error);
                toast.error('Error al eliminar el menú');
            })
            .finally(() => setLoading(false));
    };

    const onChangeConfirm = (e: React.ChangeEvent<HTMLInputElement>) => {
        setConfirmText(e.target.value);
    };

    const isConfirmed = confirmText.trim().toLowerCase() === 'eliminar';

    return (
        <Modal show={show} onHide={handleClose} className="mp-modal" centered>
            <div className="mp-modal-header">
                <h2 className="mp-modal-title">Eliminar Menú</h2>
                <button className="mp-modal-close" onClick={handleClose}>
                    <HiOutlineXMark size={18} />
                </button>
            </div>
            <div className="mp-modal-body">
                <p>¿Estás seguro que deseas eliminar el menú <strong>{menu?.menu_name}</strong>?</p>
                <div className="mp-form-group">
                    <label className="mp-form-label">Para confirmar, escribe <strong>eliminar</strong>:</label>
                    <input
                        className="mp-form-input"
                        type="text"
                        value={confirmText}
                        onChange={onChangeConfirm}
                        placeholder="Escribe eliminar"
                        disabled={loading}
                    />
                </div>
                {loading && <MiniLoadingSpinner />}
            </div>
            <div className="mp-modal-footer">
                <button className="mp-modal-btn-cancel" onClick={handleClose} disabled={loading}>
                    Cancelar
                </button>
                <button
                    className="mp-modal-btn-submit"
                    style={{ background: 'linear-gradient(135deg, #ef4444, #dc2626)' }}
                    onClick={handleDeleteMenu}
                    disabled={!isConfirmed || loading}
                >
                    Eliminar
                </button>
            </div>
        </Modal>
    );
};

export default DeleteMenuModal;
